<div class="pos-relative"
     (offClick)="toggle(false)"
     [offClickOff]="!openState.value">
    <div class="flex flex-middle cursor-pointer"
         (click)="toggle()">
        <span class="p1">
            @if (titleTpl) {
            <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
            }
        </span>
        <i class="indicator icon-arrow-down m-l-2"
           [toggleClass]="'flip'"
           [toggleClassBy]="openState"></i>
    </div>
    <div class="pos-absolute right-0 z-1"
         [style.min-width.%]="100">
        <div [hideUp]="openState"
             class="bg-col-w">

            @for (option of options; track option) {
            <div class="cursor-pointer p-t-3 p-b-3 p-l-6 p-r-6"
                 (click)="pick(option);">
                @if (optionTpl) {
                <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: option }"></ng-container>
                }
            </div>
            }

        </div>
    </div>
</div>